<template>
    <v-container class="max-container">
        <v-row class="flex-row-center">
            <v-card class="card__border-radius" width="100%" v-if="hasActivities">
                <v-card-text>
                    <v-container class="historic__container">
                        <v-data-table
                            :headers="headers"
                            :items="activities"
                            :loading="tableLoading"
                            mobile-breakpoint="300"
                            hide-default-footer
                            disable-pagination
                            class="historic__data-table">
                        </v-data-table>
                    </v-container>
                    <v-container class="flex-col-start savings__div">
                        <strong>Você Economizou:</strong>
                        <span class="savings__div_value">{{ 'R$' + savedMoney.toFixed(2) }}</span>
                    </v-container>
                </v-card-text>
            </v-card>

            <div v-if="!hasActivities" class="flex-col-center w-100">
                <h3 class="text-center"> Ainda não existem atividades... </h3>

                <v-img :max-width="dynamicWidthImg" class="empty--img" src="@/assets/emptyView-notifications.svg" />
            </div>
        </v-row>        
    </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Services
import { getEventsByCurrentContactIdAndCompanyId, getSavedMoneyByCompanyIdAndCurrentContactId } from "@/app/components/historic/service/historic.service";

export default {
    name: 'Historic',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
         headers: [
          { text: 'Data', align: 'center', value: 'date', },
          { text: 'Horário', value: 'hour' },
          { text: 'Atividade', value: 'typename' },
          { text: 'Descrição', value: 'description' }
        ],
        activities: [],
        hasActivities: true,
        dynamicWidthImg: '60%',
        tableLoading: false,
        eventTypes: [1,2,3,4,5,6,7,9,11],
        savedMoney: 0
    }),
    created() {
        window.addEventListener("resize", this.compareWidth);
        this.getAllScreenInfo()
    },
    methods: {
        ...mapActions('historicLoaderStore', ['SET_ACTIVITIES_STATE']),
        compareWidth() {
            ( window.innerWidth < 640)? this.dynamicWidthImg = '80%' : this.dynamicWidthImg = '60%';
        },
        getAllScreenInfo() {
            this.tableLoading = true
            getEventsByCurrentContactIdAndCompanyId( this.currentCompany.id, this.eventTypes )
                .then( success => {
                        if( success.data.length == 0 ) {
                            this.hasActivities = false
                        } else {
                            this.hasActivities = true
                            this.activities = success.data
                            this.activities.forEach( element => {
                                element.hour = this.getHourByTimeStamp(element.dateadded)
                                element.date = this.getDateByTimeStamp(element.dateadded)
                            })
                        }
                        this.tableLoading = false
                        this.SET_ACTIVITIES_STATE(true)
                    }
                )
                .catch( error => {
                        this.hasActivities = false
                        this.tableLoading = false
                        this.SET_ACTIVITIES_STATE(true)

                        if ( error != null ) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
            
            
            
            
            getSavedMoneyByCompanyIdAndCurrentContactId(this.currentCompany.id)
            .then( success => {
                this.savedMoney = success.data.savedMoney
            })
            .catch( error => ( error != null ) ? this.$toasted.show(error.message, { type: 'error' } ) : '' )
        },
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        }
        
    }
}
</script>

<style>
@media (max-width: 959px) {
    .text-center {
        text-align: center;
    }
}
@media ( max-width: 600px) {
    .historic__row{
        flex-direction: column;
    }   
}
.savings__div{
    font-size: 18px;
    font-weight: 800;
    margin-top: 25px;
}
.savings__div_value{
    color: var(--cor--verde);
    margin-top: 10px;
    font-weight: 600 !important;
}
.historic__container {
    overflow: auto;
    width: 100%;
    max-height: 300px;
}
.historic__data-table {
    overflow-x: auto !important;
    min-width: 600px;
    color: var(--cor--preta);
}
.empty--img {
    margin-top: 24px;
}

</style>